module.exports = __webpack_public_path__ + "img/swimming.7da8d5d8.svg";